import { ECexBotFilter } from 'types/bots/cex/bot-states';
import { IChartRange, IChartTimeframe } from 'types/charts';

export const chartVolumeBarColor = '#adb5bd';
export const internalVolumeBarColor = '#940000';

export const CHARTS_COLORS = [
  '#FFB800',
  '#9152FF',
  'rgb(0, 102, 204)',
  '#03A356',
  '#0047FF',
  '#5932EA',
  '#FFDE89',
  '#A2D2FF',
  '#02FB83',
  '#c2582b',
  '#67FFD1',
  '#DDCDFC',
  '#2B1E59',
  '#003f5c',
  '#2f4b7c',
  '#665191',
  '#a05195',
  '#d45087',
  '#f95d6a',
  '#ff7c43',
  '#FF8A00',
];

export const CHARTS_COMMON_COLOR = '#FFFFFF';

export const CHART_RANGES: { label: IChartRange; milliseconds: number }[] = [
  { label: '1H', milliseconds: 60 * 60 * 1000 },
  { label: '1D', milliseconds: 24 * 60 * 60 * 1000 },
  { label: '7D', milliseconds: 7 * 24 * 60 * 60 * 1000 },
  { label: '1M', milliseconds: 30 * 24 * 60 * 60 * 1000 },
  { label: '3M', milliseconds: 3 * 30 * 24 * 60 * 60 * 1000 },
  { label: '1Y', milliseconds: 12 * 30 * 24 * 60 * 60 * 1000 },
  { label: 'ALL', milliseconds: Date.now() },
];

export const CHART_TIMEFRAMES: IChartTimeframe[] = ['1m', '5m', '15m', '1h', '4h', '24h', '168h'];

export const CHART_DEX_TIMEFRAMES: IChartTimeframe[] = ['1m', '5m', '15m', '1h', '4h', '24h'];

export const CEX_FILTER_BOTS: {
  label: string;
  id: ECexBotFilter;
}[] = [
  {
    label: 'Buy sell',
    id: ECexBotFilter.buy_sell,
  },
  {
    label: 'Buy sell v2',
    id: ECexBotFilter.buy_sell_v2,
  },
  {
    label: 'Orderbook grid',
    id: ECexBotFilter.order_book,
  },
  {
    label: 'Delta Neutral OB',
    id: ECexBotFilter.dn_orderbook,
  },
  {
    label: 'Organic',
    id: ECexBotFilter.organic,
  },
  {
    label: 'Regular',
    id: ECexBotFilter.regular,
  },
  {
    label: 'Chart modeling',
    id: ECexBotFilter.cm,
  },
  {
    label: 'Abuse protection',
    id: ECexBotFilter.abuse_protection,
  },
  {
    label: 'Fill gaps',
    id: ECexBotFilter.fg,
  },
  {
    label: 'Counter order',
    id: ECexBotFilter.counter_order,
  },
  {
    label: 'Order manager',
    id: ECexBotFilter.order_manager,
  },
  {
    label: 'Arbitrage',
    id: ECexBotFilter.arbitrage,
  },
  {
    label: 'Unknown',
    id: ECexBotFilter.unknown,
  },
  {
    label: 'Orderbook dynamic',
    id: ECexBotFilter.orderbook_dynamic,
  },
];

export const chartNames = {
  dex: {
    pair: 'pair-dex',
    balances: 'balances-dex',
  },
  sol: {
    pair: 'pair-sol',
    balances: 'balances-sol',
  },
  cexOld: {
    pair: 'pair-old',
    balances: 'balances-old',
  },
  cex: {
    pair: 'pair',
    balances: 'balances',
  },
};
